import { AlertCircle, BarChart3, CalendarDays, Users } from 'lucide-react';

import { useGetAverageAttendance } from '~entities/classes/api/get-average-attendance';
import { useGetAverageDropRate } from '~entities/classes/api/get-average-drop-rate';
import { useGetAgeDistribution } from '~entities/studios/api/get-age-distribution';
import { useStudioStore } from '~entities/studios/model/studio-store';

import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from '~shared/shadcn/ui/card';

interface MetricStripProps {
  sessionId?: string;
}

export function MetricStrip({ sessionId }: MetricStripProps) {
  const studio = useStudioStore();

  const { data: ageDistribution } = useGetAgeDistribution(
    studio.currentStudioId ?? '',
  );

  const { data: attendanceData } = useGetAverageAttendance({
    sessionId,
  });

  const { data: dropRateData } = useGetAverageDropRate({
    sessionId,
  });

  const totalStudents = ageDistribution?.totalCount;

  return (
    <div className='mb-6 grid gap-4 md:grid-cols-2 lg:grid-cols-4'>
      <Card>
        <CardHeader className='flex flex-row items-center justify-between space-y-0 pb-2'>
          <CardTitle className='text-sm font-medium'>Total Students</CardTitle>
          <Users className='size-4 text-muted-foreground' />
        </CardHeader>
        <CardContent>
          <div className='text-2xl font-bold'>{totalStudents ?? 0}</div>
        </CardContent>
      </Card>
      <Card>
        <CardHeader className='flex flex-row items-center justify-between space-y-0 pb-2'>
          <CardTitle className='text-sm font-medium'>
            Average Attendance
          </CardTitle>
          <BarChart3 className='size-4 text-muted-foreground' />
        </CardHeader>
        <CardContent>
          {attendanceData ? (
            <div className='text-2xl font-bold'>
              {attendanceData.averageAttendance * 100}%
            </div>
          ) : null}
        </CardContent>
      </Card>
      <Card>
        <CardHeader className='flex flex-row items-center justify-between space-y-0 pb-2'>
          <CardTitle className='text-sm font-medium'>Total Classes</CardTitle>
          <CalendarDays className='size-4 text-muted-foreground' />
        </CardHeader>
        <CardContent>
          <div className='text-2xl font-bold'>6</div>
          <div className='mt-1 flex items-center text-xs text-muted-foreground'></div>
        </CardContent>
      </Card>
      <Card>
        <CardHeader className='flex flex-row items-center justify-between space-y-0 pb-2'>
          <CardTitle className='text-sm font-medium'>
            Average Drop Rate
          </CardTitle>
          <AlertCircle className='size-4 text-muted-foreground' />
        </CardHeader>
        <CardContent>
          {dropRateData ? (
            <div className='text-2xl font-bold'>
              {dropRateData.averageDropRate}%
            </div>
          ) : null}
        </CardContent>
      </Card>
    </div>
  );
}
